<template>
  <v-dialog v-model="dialog" max-width="780px">
    <v-card>
      <v-card-title>
       <strong></strong> Funcionamento das Taxas no Sistema
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <p>
          No sistema, há duas taxas que podem ser configuradas em um ingresso: a
          Taxa Cliente e a Taxa Produtor. Essas taxas são aplicadas de maneiras
          diferentes dependendo de como o produtor deseja configurar o preço
          final e o valor líquido a ser recebido.
        </p>
        <ul>
          <li>
            <strong>Taxa Cliente:</strong> Esse valor é adicionado ao preço do
            ingresso e é pago pelo cliente. Essa taxa não afeta o valor líquido
            que o produtor recebe, mas sim o valor final que o cliente vê na
            compra.
          </li>
          <li>
            <strong>Taxa Produtor: </strong> Essa taxa é o valor que a
            plataforma cobra do produtor pela venda do ingresso. Esse valor é
            descontado do total pago pelo cliente, e o produtor vê o valor final
            líquido no seu relatório, após o desconto dessa taxa.
          </li>
        </ul>
        <v-alert type="info" dense text class="mt-3 mb-0">
          Ambas as taxas são calculadas com base no valor original do ingresso.
        </v-alert>
        <p class="font-weight-bold mt-4 text-17">
          Exemplos Práticos de Configuração de Taxas
        </p>
        <ul>
          <li>
            <strong
              >Taxa Compartilhada (Cliente e Produtor pagam igualmente):</strong
            >
            <p>
              Neste exemplo, a Taxa Cliente e a Taxa Produtor são ambas de 12%.
              Isso significa que o cliente pagará 12% a mais sobre o valor do
              ingresso (R$ 100 + 12% = R$ 112). O produtor receberá o valor do
              ingresso original (R$ 100), pois a taxa da plataforma (12%) é
              descontada, mantendo o valor líquido para o produtor.
            </p>
          </li>
          <li>
            <strong
              >Produtor Assume a Taxa (Cliente paga apenas o ingresso):</strong
            >
            <p>
              Aqui, a Taxa Cliente é 0%, o que significa que o cliente paga
              exatamente o valor do ingresso, sem acréscimos (R$ 100). Porém, o
              produtor arca com a Taxa Produtor de 12%, recebendo no final R$
              88.
            </p>
          </li>
          <li>
            <strong
              >Acréscimo de Taxa Cliente para Cashback ou Taxa Extra:</strong
            >
            <p>
              Neste caso, a Taxa Cliente é 15%, enquanto a Taxa Produtor é 10%.
              O cliente paga R$ 115 (R$ 100 + 15%), enquanto o produtor recebe
              R$ 105, após o desconto da Taxa Produtor de 10% (R$ 10). Essa
              configuração é útil quando o produtor quer repassar parte do custo
              ao cliente, mas também quer incluir um cashback ou uma taxa adicional.
            </p>
          </li>
        </ul>
        <table class="mt-3 custom-table">
          <thead>
            <tr>
              <th>Configuração</th>
              <th>Valor do Ingresso</th>
              <th>Taxa Cliente (%)</th>
              <th>Taxa Produtor (%)</th>
              <th>Valor Final Cliente</th>
              <th>Valor Recebido Produtor</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Taxa Cliente e Produtor (12% cada)</td>
              <td>R$ 100</td>
              <td>12%</td>
              <td>12%</td>
              <td>R$ 112</td>
              <td>R$ 100</td>
            </tr>
            <tr>
              <td>Produtor Assume Taxa (Cliente 0%)</td>
              <td>R$ 100</td>
              <td>0%</td>
              <td>12%</td>
              <td>R$ 100</td>
              <td>R$ 88</td>
            </tr>
            <tr>
              <td>Cashback/Acréscimo Cliente (15% e 10%)</td>
              <td>R$ 100</td>
              <td>15%</td>
              <td>10%</td>
              <td>R$ 115</td>
              <td>R$ 105</td>
            </tr>
          </tbody>
        </table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "FeeInstructions",
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
  },
};
</script>

<style>
 .custom-table {
    width: 100%;
    border-collapse: collapse;
  }
  .custom-table th,
  .custom-table td {
    border: 1px solid #ddd;
    padding: 8px;
  }
  .custom-table th {
    background-color: #f2f2f2;
  }</style>
